import { CreditApplication } from '_gql'

import useDidMount from '@divvy-web/hooks.usedidmount'

import { useAuth } from '@sputnik/auth'

interface UseApplicantTokenOnMountProps {
  salesforceCreditId: CreditApplication['salesforceCreditId']
}

const useApplicantTokenOnMount = ({ salesforceCreditId }: UseApplicantTokenOnMountProps) => {
  const { getCreditAppIdOnToken, requestApplicantToken } = useAuth()

  useDidMount(() => {
    if (getCreditAppIdOnToken() !== salesforceCreditId) requestApplicantToken(salesforceCreditId)
  })
}

export default useApplicantTokenOnMount
